import './index.css';

import React from 'react';

import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';

import App from './App';
import awsConfig from './components/aws-config';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.Auth.userPoolId,
      userPoolClientId: awsConfig.Auth.userPoolWebClientId,
      region: awsConfig.region || 'us-east-1',
      loginWith: {
        email: true,
        phone: false,
        username: false
      }
    }
  },
  
  // API configuration
  API: {
    REST: {
      'UtilityAuditProStack-API-prod': {
        endpoint: (awsConfig.API.endpoints && awsConfig.API.endpoints[0] && awsConfig.API.endpoints[0].endpoint) || '',
        region: awsConfig.region || 'us-east-1'
      }
    }
  },
  
  // Storage configuration
  Storage: {
    S3: {
      bucket: awsConfig.Storage.AWSS3.bucket,
      region: awsConfig.region || 'us-east-1'
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);